import React from 'react';
import PropTypes from 'prop-types';

import { TranslatedTextMessage } from './TranslatedTextMessage';

import Button from 'common/components/Button';

const AgreeButton = ({
  selectedState,
  onClick,
  messageId,
  minimumAge,
  disabled,
}) => {
  return (
    <Button
      id="age-gate-confirmation"
      className="age-gate__agree-button"
      onClick={() => {
        onClick(selectedState);
      }}
      disabled={disabled}
      element="button"
    >
      <TranslatedTextMessage id={messageId} inlineData={{ age: minimumAge }} />
    </Button>
  );
};

AgreeButton.propTypes = {
  selectedState: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  messageId: PropTypes.string.isRequired,
  minimumAge: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default AgreeButton;
